import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import MlmorderEditForm from './MlmorderEditForm';
import MlmorderList from './MlmorderList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import MlmorderListView from './MlmorderListView'


export default function MlmorderDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.dmpslice.mlmorderDashboard);
  const [ mlmorderId, setMlmorderId] = React.useState('');
  const [reloadMlmorderList, setReloadMlmorderList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <MlmorderEditForm 
            setReloadMlmorderList={setReloadMlmorderList}
            mlmorderId={mlmorderId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <MlmorderListView 
                      setMlmorderId = {setMlmorderId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
